var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.001,
    height: 80,
    viewBox: "0 0 80.001 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playIcon",
    transform: "translate(-245.6 -245.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M245.6,287.939v-4.687a5.334,5.334,0,0,0,.133-.674,37.623,37.623,0,0,1,4.565-15.752c6.222-11.264,15.671-18.163,28.33-20.595,1.525-.293,3.082-.425,4.624-.631h4.687a4.266,4.266,0,0,0,.6.128,37.027,37.027,0,0,1,15.762,4.547c13.144,7.361,20.3,18.608,21.222,33.653a36.633,36.633,0,0,1-4.645,20.433c-7.342,13.116-18.595,20.239-33.607,21.166a37.082,37.082,0,0,1-20.438-4.633,39.4,39.4,0,0,1-20.606-28.337C245.938,291.034,245.806,289.479,245.6,287.939Zm40.1-34.35A32.007,32.007,0,1,0,317.6,285.7,32.15,32.15,0,0,0,285.7,253.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M400.757,389.994c0-3.566-.006-7.131.006-10.7a7.437,7.437,0,0,1,.145-1.626,2.641,2.641,0,0,1,3.86-1.994,11.229,11.229,0,0,1,1.391.7q9.156,5.277,18.3,10.568a11.164,11.164,0,0,1,1.239.81,2.719,2.719,0,0,1-.022,4.6,11.042,11.042,0,0,1-1.173.769q-9.216,5.329-18.444,10.637a8,8,0,0,1-2.079.838,2.347,2.347,0,0,1-2.916-1.688,7.371,7.371,0,0,1-.3-2.067C400.742,397.229,400.757,393.612,400.757,389.994Z",
    transform: "translate(-124.854 -104.452)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.525335367446616d9d5a248e00c90a28.svg";
export { ForwardRef as ReactComponent };